import { Box, Button, Card, Grid, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import { DataGridPro as DataGrid } from "@mui/x-data-grid-pro";
import { useFormik } from "formik";
import { useState } from "react";
import ReportsService from "services/reports";
import { ptBR_DataGrid } from "utils/datagrid";
import * as XLSX from "xlsx";

const initialValues = {
  tipo: "venda",
};

export default function PedidosSemContas() {
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState([]);

  const widths = [120, 100, 200, 100, 120, 120, 120];

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async (values) => {
      setLoading(true);

      try {
        const data = await ReportsService.pedidosSemContas({
          tipo: values.tipo,
        });

        if (!data.length) {
          alert("Nenhum pedido com problema encontrado");
        }

        setReport(data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        alert("Erro ao buscar pedidos com problemas");
        setLoading(false);
      }
    },
  });

  const exportToExcel = (data) => {
    // Criar um novo workbook
    const workbook = XLSX.utils.book_new();

    // Converter os dados para worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Adicionar a worksheet ao workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Pedidos Sem Contas");

    // Gerar e baixar o arquivo Excel
    XLSX.writeFile(
      workbook,
      `pedidos_sem_contas_${formik.values.tipo}_${new Date().getTime()}.xlsx`
    );
  };

  return (
    <DashboardLayout>
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h6" color="white" mt={1}>
                  Relatório de Pedidos com Problemas de Contas
                </MDTypography>
              </MDBox>
              <MDBox pt={3} mx={2} py={3} px={2}>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 2,
                    mb: 2,
                  }}
                  component="form"
                  onSubmit={formik.handleSubmit}
                >
                  <TextField
                    id="tipo"
                    name="tipo"
                    label="Tipo de Pedido"
                    value={formik.values.tipo}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={loading}
                    error={formik.touched.tipo && Boolean(formik.errors.tipo)}
                    helperText={formik.touched.tipo && formik.errors.tipo}
                    sx={{
                      width: "100%",
                    }}
                    select
                    SelectProps={{
                      native: true,
                    }}
                  >
                    <option value="venda">Venda</option>
                    <option value="compra">Compra</option>
                  </TextField>

                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                    sx={{
                      justifySelf: "center",
                      width: "100%",
                      color: "white !important",
                    }}
                  >
                    {loading ? "Carregando..." : "Buscar Pedidos"}
                  </Button>
                </Box>
              </MDBox>
            </Card>

            {report.length > 0 && (
              <>
                <Card sx={{ marginTop: 4 }}>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="success"
                    borderRadius="lg"
                    coloredShadow="success"
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <MDTypography variant="h6" color="white" mt={1}>
                      Resultados - {report.length} pedido(s) encontrado(s)
                    </MDTypography>
                  </MDBox>
                  <DataGrid
                    initialState={{
                      pagination: { paginationModel: { pageSize: 100 } },
                    }}
                    pageSizeOptions={[100, 200]}
                    rows={report.map((row, index) =>
                      Object({ ...row, id: index })
                    )}
                    columns={[
                      {
                        headerName: "Número do Pedido",
                        field: "numPedido",
                        flex: 1,
                        minWidth: widths[0],
                      },
                      {
                        headerName: "Tipo",
                        field: "tipo",
                        flex: 1,
                        minWidth: widths[1],
                      },
                      {
                        headerName: "Problema",
                        field: "problema",
                        flex: 1,
                        minWidth: widths[2],
                      },
                      {
                        headerName: "Data",
                        field: "data",
                        flex: 1,
                        minWidth: widths[3],
                      },
                      {
                        headerName: "Total do Pedido",
                        field: "totalPedido",
                        flex: 1,
                        minWidth: widths[4],
                        valueFormatter: (value) => {
                          return value !== null && value !== undefined
                            ? `R$ ${value.toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`
                            : "-";
                        },
                      },
                      {
                        headerName: "Total das Contas",
                        field: "totalContas",
                        flex: 1,
                        minWidth: widths[5],
                        valueFormatter: (value) => {
                          return value !== null && value !== undefined
                            ? `R$ ${value.toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`
                            : "-";
                        },
                      },
                      {
                        headerName: "Diferença",
                        field: "diferenca",
                        flex: 1,
                        minWidth: widths[6],
                        valueFormatter: (value) => {
                          return value !== null && value !== undefined
                            ? `R$ ${value.toLocaleString("pt-BR", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}`
                            : "-";
                        },
                      },
                    ]}
                    rowCount={report.length}
                    rowSelection={false}
                    localeText={ptBR_DataGrid}
                    sx={{
                      margin: 2,
                      ".MuiDataGrid-virtualScroller": {
                        minHeight: "100px",
                      },
                    }}
                    disableColumnFilter
                    headerFilters
                    slots={{
                      headerFilterMenu: null,
                    }}
                  />
                </Card>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => exportToExcel(report)}
                    sx={{
                      color: "white !important",
                    }}
                  >
                    Exportar para Excel
                  </Button>
                </Box>
              </>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
